import * as React from "react";
import type { SVGProps } from "react";
const SvgVipIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="vip_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M742.315 245.461a106.555 106.555 0 0 1 87.125 45.184l131.584 186.71a106.581 106.581 0 0 1-18.347 142.805L580.736 925.653a106.539 106.539 0 0 1-137.472 0L81.365 620.16A106.539 106.539 0 0 1 63.02 477.355l131.541-186.71a106.539 106.539 0 0 1 87.125-45.226h112L352 136.064l102.827 35.968L512 64l57.173 107.99L672 136.02l-41.685 109.44h112zm-460.63 85.078a21.419 21.419 0 0 0-17.536 9.13L132.565 526.38a21.419 21.419 0 0 0 3.712 28.757L498.176 860.63a21.461 21.461 0 0 0 27.648 0l361.899-305.493c8.533-7.168 10.112-19.627 3.712-28.757L759.85 339.669a21.461 21.461 0 0 0-17.494-9.13H281.643zm106.411 94.89L512 623.701 635.904 425.43a42.581 42.581 0 0 1 72.192 45.142L564.352 700.544a61.781 61.781 0 0 1-104.704 0L315.904 470.571a42.581 42.581 0 0 1 72.192-45.184z"
    />
  </svg>
);
export default SvgVipIcon;
